module.exports = __webpack_public_path__ + "img/full5-min.7115f7d2.png";